// extracted by mini-css-extract-plugin
module.exports = {"root":"error-boundary_root__U5Ep3"};